import '../scss/index.scss';  // Causes the styles to be loaded on the page
import { game } from './gameManager';
import { sounds } from './soundManager';
import { getOneByClass } from './util';


function main() {
    game.createElement();

    const cover = getOneByClass("cover");
    const gameDiv = getOneByClass("game");
    const startButton = getOneByClass("start");
    startButton.onclick = () => {
        cover.style.display = "none";
        gameDiv.style.display = "flex";

        sounds.start();
    }
}

window.addEventListener('load', main);
